import styled from 'styled-components';

export const IntegrationTabStyle = styled.div`
  position: relative;
  font-size: 15px;
  line-height: 1.55;
  color: var(--ink);

  .title {
    display: block;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
    margin: 0 0 6px;
    color: var(--ink);
  }

  .text-box {
    position: relative;
    flex-grow: 1;
    padding: 0 0 0 55px;
    color: var(--mute);

    .icon {
      position: absolute;
      top: 2px;
      left: 0;
      width: 45px;
    }

    p {
      margin: 0;
      color: var(--mute);
    }
  }

  .holder {
    margin: 0 0 16px;
    padding: 18px 20px;
    background: var(--white);
    border: 1px solid var(--line);
    border-radius: var(--r-lg);
    box-shadow: var(--shadow-soft);

    > p {
      margin: 0;
      color: var(--mute);
      font-size: 14px;
    }

    &.flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
    }
  }
`;
